import { getLanguage, type LanguageCode, type Local } from '../entities/auth/local.enum';

let sessionUserId: string | null = null;

/**
 * Applies the profile language once per logged-in user.
 * A later call for the same user does nothing, so a manual language switch sticks
 * until logout (or a different user signs in).
 */
export async function applyLanguageForSession(
  userId: string,
  readPreferredLocal: () => Promise<Local | null | undefined>,
  apply: (language: LanguageCode) => void,
): Promise<void> {
  if (sessionUserId === userId) return;
  const preferredLocal = await readPreferredLocal();
  if (sessionUserId === userId) return;
  sessionUserId = userId;
  if (!preferredLocal) return;
  apply(getLanguage(preferredLocal));
}

export function clearLanguageSession(): void {
  sessionUserId = null;
}
